goog.provide('el8.data.referencedPracticians');

goog.require('el8.model.base');


el8.data.referencedPracticians = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('fullName');

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) { 
            var modelClass = el8.model.idToModelClass(id);
            if (modelClass === 'Physician') {
                return '/referenced-physicians/'+id+'/'; 
            } else if (modelClass === 'OfficeStaff') {
                return '/referenced-staff/'+id+'/'; 
            }
        }
    });
})();


